import React, { Component ,Fragment} from 'react';
import { Label} from 'reactstrap';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './quilltable.css';

export class Editor extends Component {
    constructor(props) {
        super(props)  
        this.quillRef = null;      // Quill instance
        this.reactQuillRef = null; // ReactQuill component
    
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleHookChange = this.handleHookChange.bind(this);
        //this.onInsertTableColumnRight = this.onInsertTableColumnRight.bind(this);
        //this.onInsertTableRowBelow = this.onInsertTableRowBelow.bind(this);
        //this.onDeleteTableRow = this.onDeleteTableRow.bind(this);

        this.state = {
            hook: this.props.hook?this.props.hook:"",
            content: this.props.content?this.props.content:"",
        }

        var Block = ReactQuill.Quill.import('blots/block');
        Block.tagName = 'div';
        ReactQuill.Quill.register(Block);
    }

    handleHookChange = (html) => {
        this.setState({
          hook: html
        });
        this.props.onHookChange(html);
    }

    handleContentChange = (html) => {
        this.setState({
            content: html
        });
        this.props.onContentChange(html);

    }

    modules = {
        toolbar: [
          [{ 'header': [1, 2, 3]}, { 'font': [] }],
          [{size: []}],
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, 
           {'indent': '-1'}, {'indent': '+1'}],
          ['link', 'image', 'video'],
          ['clean']
        ],
        //table: true,
        clipboard: {
          // toggle to add extra line breaks when pasting HTML:
          matchVisual: false,
        }
      }

    formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video'
      ]
/*
    onInsertTableColumnRight() {
        const tableModule = this.quillRef.getModule('table')
        tableModule.insertColumnRight()
    }

    onInsertTableRowBelow() {
        const tableModule = this.quillRef.getModule('table')
        tableModule.insertRowBelow()
    }
    
    onDeleteTableRow() {
        const tableModule = this.quillRef.getModule('table')
        tableModule.deleteRow()
    }
    

    componentDidMount() {
        this.attachQuillRefs()
    }
    
    componentDidUpdate() {
        this.attachQuillRefs()
    }
    
    attachQuillRefs = () => {
        if (typeof this.reactQuillRef.getEditor !== 'function') return;
        this.quillRef = this.reactQuillRef.getEditor();
    }

    ref={(el) => { this.reactQuillRef = el }}
    */
    render () {


      return (
        <Fragment>
            {this.props.onHookChange &&
            <div>
                <div className="row">
                    <div className="col-sm-2">  
                        <Label className="col-2m-2">Hook</Label>
                    </div>
                    <div className="col-sm-10">  

                        <ReactQuill 
                        theme='snow'
                        onChange={this.handleHookChange}
                        value={this.state.hook}
                        modules={this.modules}
                        formats={this.formats}
                        placeholder={this.props.placeholder}
                        />
                    </div>
                </div>   
            </div>  
            }            
            {this.props.onContentChange &&     
            <div>
                <div className="row">
                    <div className="col-sm-2">  
                        <Label className="col-2m-2">Content</Label>
                    </div>
                    <div className="col-sm-10">  
                    {/*
                        <button style={{margin: "8px"}} type="button" className="btn btn-secondary" onClick={this.onInsertTableRowBelow}>Insert Row Below</button>
                        <button style={{margin: "8px"}} type="button" className="btn btn-secondary" onClick={this.onDeleteTableRow}>Delete Row</button>
                        <button style={{margin: "8px"}} type="button" className="btn btn-secondary" onClick={this.onInsertTableColumnRight}>Insert Column Right</button>
                    */}
                        <ReactQuill                         
                        theme='snow'
                        onChange={this.handleContentChange}
                        value={this.state.content}
                        modules={this.modules}
                        formats={this.formats}
                        placeholder={this.props.placeholder}
                        />
                    </div>
                </div>   
            </div> 
            }

        </Fragment>
        )
    }
  }
  export default Editor
